// src/config/firebase.config.js
// ─────────────────────────────────────────────────────────────────────────────
//  Firebase project credentials — single source of truth.
//
//  PHASE 5: Extracted from src/lib/firebase.js to separate config from
//  initialization logic. firebase.js now imports from here.
//
//  ALL values come from Vite environment variables (.env / .env.local).
//  Never hardcode real credentials here — the .env.example file documents
//  the required variable names for new developers.
//
//  Required .env variables:
//    VITE_FIREBASE_API_KEY
//    VITE_FIREBASE_AUTH_DOMAIN
//    VITE_FIREBASE_PROJECT_ID
//    VITE_FIREBASE_STORAGE_BUCKET
//    VITE_FIREBASE_MESSAGING_SENDER_ID
//    VITE_FIREBASE_APP_ID
//    VITE_FIREBASE_MEASUREMENT_ID   (optional — only needed for Analytics)
//
//  Other Vite env vars used elsewhere in the app (not Firebase config, but
//  also required for full functionality):
//    VITE_UPLOAD_WORKER_URL   — disciplesheep-upload Worker base URL (Stewardship.jsx)
//    VITE_R2_PUBLIC_URL       — R2 public bucket URL, used to parse R2 keys on delete (Stewardship.jsx)
//
//  Usage:
//    import { firebaseConfig } from '@/config/firebase.config';
// ─────────────────────────────────────────────────────────────────────────────

export const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId:     import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};